import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { LogStreamRow } from '@portal-core/processes/models/log-stream-row.model';

@CollectionStateSelectors({
  stateType: LogStreamRowState
})
@State<LogStreamRowState>({
  name: LogStreamRowState.source,
})
@Service({ autoProvided: false })
export class LogStreamRowState extends CollectionStateBase {
  static override source = 'LogStreamRow';
  getSource(): string {
    return LogStreamRowState.source;
  }
}

@Service()
export class LogStreamRowDataService extends CollectionDataServiceBase<LogStreamRow> {
  protected readonly stateType = LogStreamRowState;
}
